import React, { ChangeEvent, ReactElement } from 'react'
import { FieldError } from 'react-hook-form'
import DynamicFormattedMessage from '../common/ui/DynamicFormattedMessage'
import ErrorMessage from './ErrorMessage'

function Checkbox({
  name,
  id,
  register,
  error,
  customClass = '',
  defaultValue,
  values,
  wrapperClass,
  hasLabel = true,
  disabled = false,
  onChange,
}: {
  name: string
  id: string
  register: (ref: HTMLInputElement) => void
  error?: FieldError | undefined
  customClass?: string
  defaultValue?: boolean
  values?: {}
  wrapperClass?: string
  hasLabel?: boolean
  disabled?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}): ReactElement {
  return (
    <div className={`inputGroup ${customClass}`}>
      <div className={`inputCheckboxWrapper ${wrapperClass} dInlineFlex`}>
        {hasLabel ? (
          <DynamicFormattedMessage
            tag="label"
            id={`form.field.${name}.label`}
            className="inputLabel"
            htmlFor={id}
            values={values}
          />
        ) : (
          <label htmlFor={id} className="inputLabelEmpty">
            {name}
          </label>
        )}

        <input
          name={name}
          type="checkbox"
          id={id}
          ref={register}
          className="inputCheckboxField"
          defaultChecked={defaultValue}
          disabled={disabled}
          onChange={onChange}
        />
        <span className="inputCheckboxControl" />
      </div>

      <ErrorMessage error={error} />
    </div>
  )
}

export default Checkbox
